export const isBackspaceKey = (keyCode: number, key: string) => keyCode === 8 || key === 'Backspace'
export const isDeleteKey = (keyCode: number, key: string) => keyCode === 46 || key === 'Delete'

export const isSpaceBarKey = (keyCode: number, key: string) =>
  keyCode === 32 || key === ' ' || key === 'Spacebar' || key === 'Space'
export const isLeftArrowKey = (keyCode: number, key: string) =>
  keyCode === 37 || key === 'ArrowLeft'
export const isRightArrowKey = (keyCode: number, key: string) =>
  keyCode === 39 || key === 'ArrowRight'
